import fetch from './fetch'

/********       基础接口      ********/
export const GetBaseInfo = params => { return fetch.post('/base_info/getBaseInfo',params) }//获取基本信息
export const GetProductList = params => { return fetch.post(`/base_info/getProductList`, params) }//获取产品列表
export const GetProductData = params => { return fetch.post('/base_info/getProductData',params) }//获取产品数据信息
export const AddMaterialType = params => { return fetch.post('/base_info/addMaterialType',params) }//获取基本信息


export const TranslateText = params => { return fetch.post(`/base_info/translateText`, params) }




// WEBPACK FOOTER //
// ./src/api/index.js